<template>

    <li class="dropdown">
        <a href="#" class="dropdown-toggle icon-circle img-circle " style="font-size: 12px" data-toggle="dropdown">
            <span class="fa fa-bell"></span>
            ALERTAS <span class="badge" v-if="total">{{total}}</span> <b class="caret"></b>
        </a>
        <ul class="dropdown-menu">
            <!--
            <li v-for="a in alerts">
                <a @click="clickAlerta(a.id_alertas)" style="cursor: pointer">
                    <span class="label label-warning">{{a.placa}}</span> {{a.titulo}}
                </a>
            </li>
            <li class="divider"></li>
            -->
            <li><a href="#/alertas" class="text-center">VER TODOS</a></li>
        </ul>
    </li>

</template>
<script>
    import { Alerts } from "../../class/alerts";
    import { SET_ALERTAS } from "../../mutation-types";

    export default {
        data () {
            return {
                id: null,
                total: 0,
                interval: null,
                alerts: []
            }
        },

        beforeMount () {
            this.interval = setInterval(() => this.count(), 180000);
            this.count();
            // this.lasts();
        },
        async beforeDestroy () {
            clearInterval(this.interval);
        },
        methods: {
            clickAlerta(id) {
                this.$store.commit(SET_ALERTAS, id);
            },

            async count () {
                let count = await Alerts.count();
                if (count > 100) {
                    this.total = "+100";
                } else {
                    this.total = count;
                }
            },

            async lasts () {
                this.alerts = await Alerts.lasts();
            }
        }
    }
</script>

<style scoped>

</style>
